import React from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'components/Generic/PageContent';
import InboundStockList from './InboundStockList';

const InboundStockPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <PageContent title={t('stocks.inbound.title')}>
      <InboundStockList />
    </PageContent>
  );
};
export default InboundStockPage;
